import type { StationRole } from '@/objects/generated';
import { addSecondsToDate, compareDateTimes } from './dateutils';

export const hasStartControlWarning = (startTime: Date, stationRole: StationRole, time: Date): boolean => {
    // double check if the stationRole has the flag
    if (stationRole.StartControl === false) {
        return false;
    }

    // Find the StartControlMin. Note: This has to be negative number if we want to check before the starttime
    const startControlMin = stationRole.StartControlMin ?? 0;

    // Calculate the cutoff for when we should show the warning
    const cutoffEarly = addSecondsToDate(startTime, startControlMin);
    const cutoffLate = addSecondsToDate(startTime, stationRole.StartControlMax ?? 0);

    // If the time on the startcontrol station is before the cutoff, we show the warning
    if (compareDateTimes(time, cutoffEarly) < 0) {
        return true;
    } else if (compareDateTimes(time, cutoffLate) > 0) {
        return true;
    } else {
        // Reset the warning, we probably got a new time that is inside the window
        return false;
    }
};
